import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { dateIt } from "@/lib/format";
import { Users } from "lucide-react";

export function PannelloDipendentiGiorno({ data }) {
  const giorno = (data || "").slice(0, 10);
  const { data: lista = [] } = useQuery({
    queryKey: ["stato-giorno", giorno],
    queryFn: async () => (await api.get("/ore/stato-giorno", { params: { data: giorno } })).data,
    enabled: /^\d{4}-\d{2}-\d{2}$/.test(giorno),
  });
  const fatti = lista.filter((d) => d.registrato).length;
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-4" data-testid="pannello-dipendenti-giorno">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
          <Users className="h-4 w-4 text-primary" /> Dipendenti · {giorno ? dateIt(giorno) : "—"}
        </div>
        <span className="text-xs text-slate-500" data-testid="pannello-dipendenti-conteggio">{fatti}/{lista.length} registrati</span>
      </div>
      <div className="flex flex-wrap gap-2 max-h-36 overflow-y-auto pr-1" data-testid="pannello-dipendenti-lista">
        {lista.map((d) => (
          <span
            key={d.dipendente_id}
            className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs ${d.registrato ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-slate-200 bg-slate-50 text-slate-500"}`}
            data-testid={`stato-dip-${d.codice}`}
            data-registrato={d.registrato ? "si" : "no"}
          >
            <span className={`h-2 w-2 rounded-full ${d.registrato ? "bg-emerald-500" : "bg-slate-300"}`} />
            {d.nome}
          </span>
        ))}
        {lista.length === 0 && <span className="text-xs text-slate-400">Nessun dipendente attivo.</span>}
      </div>
    </div>
  );
}
